export enum Action {
  UPDATE_STEP = "UPDATE_STEP",
  UPDATE_PURCHASE_ORDER = "UPDATE_PURCHASE_ORDER",
  UPDATE_QUANTITY_PURCHASED = "UPDATE_QUANTITY_PURCHASED",
  UPDATE_SELECTED_BULK_TICKET_FORM_ID = "UPDATE_SELECTED_BULK_TICKET_FORM_ID"
}
